import React from 'react';
import SettingsForm from '../../../components/settings/settings-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as settingsActions from '../../../actions/settings';
import Loading from '../../../components/loading';
import AdminItemPageContainer from '../admin-item-page-container';
import LocalizedStrings from '../../../localization/strings';

class SeasonContainer extends AdminItemPageContainer {

    getBaseUrl() {
        return '/admin/settings';
    }

    fetchItem() {
        return this.props.actions.fetchSettings();
    }

    render() {
        const {actions, loading} = this.props;

        return (
            <div className="panel">
                <header className="panel-header">{LocalizedStrings.settingsEdit}</header>
                <div className="panel-body">
                    {loading
                        ? <Loading/>
                        : <SettingsForm submit={actions.submitSettings}></SettingsForm>
}
                </div>
            </div>
        )

    }
}

export default connect(function(state) {
    return {loading: state.settings.loading};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...settingsActions
        }, dispatch)
    };
})(SeasonContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/settings/settings-container.js